import React, { useState } from 'react';

import styled from '@emotion/styled';

import { ChevronDown } from '../Icons/ChevronDown';
import { ChevronUp } from '../Icons/ChevronUp';

interface CollapsableControlProps {
  isCollapse: boolean;
  setIsCollapse: (...args: any) => void;
}

const CollapsableControl: React.FC<CollapsableControlProps> = ({
  isCollapse,
  setIsCollapse,
}) => {
  return (
    <Control onClick={() => setIsCollapse(!isCollapse)}>
      {isCollapse ? <ChevronUp /> : <ChevronDown />}
    </Control>
  );
};

const Control = styled.div`
  display: flex;
  cursor: pointer;
`;

interface FieldCollapseGroupProps {
  children: React.ReactNode;
  title?: string | React.ReactNode;
}

const FieldCollapseGroup: React.FC<FieldCollapseGroupProps> = ({
  children,
  title,
}) => {
  const [isCollapse, setIsCollapse] = useState(false);
  return (
    <Container>
      <LabelSection>
        {title && <Label>{title}</Label>}

        <CollapsableControl
          isCollapse={isCollapse}
          setIsCollapse={setIsCollapse}
        />
      </LabelSection>
      {isCollapse && children}
    </Container>
  );
};

export default FieldCollapseGroup;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
  /* background-color: rgba(91, 145, 245, 0.04); */

  &.collapse {
    gap: 0px;
  }
`;

const LabelSection = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background-color: rgba(91, 145, 245, 0.04);
`;

interface LabelProps {
  border?: boolean;
  rmHeaderBorder?: boolean;
  continuousView?: boolean;
  bgColor?: string;
  firstColumnOffset?: string;
}

const Label = styled.div<LabelProps>`
  font-size: 15px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.grayTextColor};
  width: fit-content;
  user-select: none;

  @media (max-width: 884px) {
    font-size: 16px;
  }
`;
